/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TestConnectionResponse = {
    connected: boolean;
    providerType?: TestConnectionResponse.providerType;
};
export namespace TestConnectionResponse {
    export enum providerType {
        LEXOFFICE = 'lexoffice',
        SEVDESK = 'sevdesk',
        TEBUTO = 'tebuto',
    }
}

